// @flow

export const MAILBOX_SA_QUANTITY_MAX = 500;
